import React from "react";
import { Box, Typography, CardContent, useTheme } from "@mui/material";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { StyledCard } from "../../common/StyledCard";
import { formatCurrency } from "../../../utils/currencyUtils";
import { PaymentPreferenceBiDto } from "../../../shared/dtos/bi/PaymentPreferenceBiDto";

interface PaymentPreferencesWidgetProps {
  data?: PaymentPreferenceBiDto[];
}

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#8884d8"];

const PaymentPreferencesWidget: React.FC<PaymentPreferencesWidgetProps> = ({
  data = [],
}) => {
  const theme = useTheme();

  return (
    <StyledCard
      sx={{ height: "100%", display: "flex", flexDirection: "column" }}
    >
      <CardContent
        sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold", mb: 3 }}>
          Payment Preferences
        </Typography>

        {data.length > 0 ? (
          <Box sx={{ flexGrow: 1, width: "100%", minHeight: 300 }}>
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={data}
                  cx="50%"
                  cy="50%"
                  innerRadius={70}
                  outerRadius={100}
                  paddingAngle={5}
                  dataKey="totalVolume"
                  nameKey="paymentMethodName"
                >
                  {data.map((_, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={COLORS[index % COLORS.length]}
                    />
                  ))}
                </Pie>
                <Tooltip
                  contentStyle={{
                    borderRadius: 8,
                    borderColor: theme.palette.divider,
                  }}
                  formatter={(value, name, props) => [
                    `${formatCurrency(Number(value))} (${props.payload.transactionCount} txns)`,
                    name,
                  ]}
                />
                <Legend verticalAlign="bottom" height={36} iconType="circle" />
              </PieChart>
            </ResponsiveContainer>
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexGrow: 1,
              minHeight: 300,
            }}
          >
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ fontStyle: "italic" }}
            >
              No payment data available.
            </Typography>
          </Box>
        )}
      </CardContent>
    </StyledCard>
  );
};

export default PaymentPreferencesWidget;
